const R = globalThis.ReactDOM;
export const createRoot = R.createRoot;
export const hydrateRoot = R.hydrateRoot;
export default R;